import React, {FC} from 'react'

const TelephonyIntegrationsPage: FC = () => {
    return (
        <div>TelephonyIntegrationsPage</div>
    )
}

export default TelephonyIntegrationsPage
